'use client';

import { c as _c } from "react/compiler-runtime";
import { useBestBetRows } from '@svs/nova-poolbetting/core/nextjs/wager/client';
import { indexToOutcomeString } from '@svs/nova-poolbetting/schema/coupon';
import type { WagerId } from '@svs/nova-poolbetting/schema/wager';
import { CouponToolboxButton } from '@svs/nova-poolbetting/ui/CouponToolbox';
import type { ReactNode } from 'react';
import { DownloadExternalFile } from './DownloadExternalFile';
type DownloadExternalFileClientContainerProps = {
  wagerId: WagerId;
  fileName: string;
};

/**
 * Component that expands and formats external rows.
 *
 * @param root0 component props
 * @param root0.wagerId id for current wager
 * @param root0.fileName output filename
 * @returns download button
 * @throws {Error} if best bet rows fail to load
 */
export function DownloadExternalFileClientContainer(t0) {
  const $ = _c(8);
  const {
    wagerId,
    fileName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const bestBetRows = useBestBetRows(wagerId, t1);
  if (bestBetRows.isLoading) {
    return;
  }
  if (bestBetRows.isError) {
    throw new Error("Failed to load best bet rows");
  }
  let t2;
  if ($[1] !== bestBetRows.data?.[0]) {
    t2 = bestBetRows.data?.[0] ?? [];
    $[1] = bestBetRows.data?.[0];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const expandedRows = t2;
  let t3;
  if ($[3] !== expandedRows) {
    t3 = expandedRows.map(_temp3);
    $[3] = expandedRows;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const rows = t3;
  if (rows.length === 0) {
    return;
  }
  let t4;
  if ($[5] !== fileName || $[6] !== rows) {
    t4 = <CouponToolboxButton asChild={true}><DownloadExternalFile rows={rows} fileName={fileName} /></CouponToolboxButton>;
    $[5] = fileName;
    $[6] = rows;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp3(srow) {
  return srow.map(_temp2).join("\r\n");
}
function _temp2(outcomeGroup) {
  return outcomeGroup.map(_temp).join("");
}
function _temp(o) {
  return indexToOutcomeString[o];
}